import React, { useEffect, useState } from "react";
import { VscOrganization } from "react-icons/vsc";
import { RiFilePaper2Fill } from "react-icons/ri";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  NavItem,
  Nav,
  NavLink,
} from "reactstrap";
import "../../App.css";
import { FaHome, FaUserGraduate, FaPhoneAlt } from "react-icons/fa";
import main from "../../assets/images/logo101.png";
import coin from "../../assets/images/goldcoin2.png";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
const navstyles = {
  color: "#fd7e14",
  backgroundColor: "#011a27",
  marginBottom: "-1.5em",
  height: "fit-content",
};
const scrollstyles = {
  color: "#fd7e14",
  backgroundColor: "#011a27 ",
  height: "fit-content",
  position: "fixed",
  top: 0,
  width: "100%",
  zIndex: "999",
  overflow: "hidden",
};
const buttonstyles = {
  color: "#fff",
  backgroundColor: "#f0810f",
};

const Navbars = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const [show, setShow] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScroll = () => {
    setShow(window.pageYOffset > 10);
  };
  const togglers = () => {
    if (window.innerWidth < 760) {
      toggle();
    }
  };

  return (
    <div>
      <Navbar
        style={show ? scrollstyles : navstyles}
        light
        expand="md"
        className="px-3 py-0  mx-auto"
      >
        <NavbarBrand href="/">
          {" "}
          <img className="logo" src={main} alt="Vibgyor logo" />{" "}
        </NavbarBrand>
        <NavbarToggler onClick={toggle} className=" navbar-dark" />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mx-auto" navbar>
            <NavItem className="nav mx-2">
              <a className="m-1 text-decoration-none" href="/">
                <FaHome size={20} className=" mb-1" />
                <span className="mx-1 ">Home</span>
              </a>
            </NavItem>
            <NavItem className="nav mx-2">
              <a className="m-1 text-decoration-none" href="/about">
                <VscOrganization size={20} className=" mb-1" />
                <span className="mx-1 ">About</span>
              </a>
            </NavItem>
            <NavItem className="nav mx-1">
              <a className="m-1 text-decoration-none" href="/services">
                <span className="mb-1">
                  <img src={coin} width="27" />
                </span>
                <span className="mx-1 ">Services</span>
              </a>
            </NavItem>
            <NavItem className="nav mx-2">
              <a className="m-1 text-decoration-none" href="/careers">
                <FaUserGraduate size={20} className=" mb-1" />
                <span className="mx-1 ">Careers</span>
              </a>
            </NavItem>
            {/* <NavItem className="nav mx-2">
              <a className="m-1 text-decoration-none" href="/contact">
                <FaPhoneAlt size={20} className=" mb-1" />
                <span className="mx-1 ">Contact Us</span>
              </a>
            </NavItem> */}
            <NavItem className="nav mx-2">
              <a className="m-1 text-decoration-none" href="/disclaimer">
                <RiFilePaper2Fill size={20} className="mb-1" />
                <span className="mx-1 ">Disclaimer</span>
              </a>
            </NavItem>
            <NavItem className="nav btn btn-warning p-0 mx-2">
              <a
                className="m-1 text-decoration-none"
                href="https://subscription.vibgyoradvisors.com/index.html"
              >
                <span className="fw-bolder">Equity Services</span>
              </a>
            </NavItem>
            <NavItem className="nav btn btn-outline-warning p-0 my-md-0 my-2 mx-2">
              <a className="m-1 text-decoration-none" href="/realestate">
                <span className="mx-1 fw-bolder ">Real Estate</span>
              </a>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default Navbars;
